import React from "react";

import { Card, Col, Row } from "@intechprev/componentes-web";
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from "../../../../entidades";

interface IProps {
  processosBeneficio: ProcessoBeneficioEntidade | null;
  plano: PlanoVinculadoEntidade | null;
}

export const Header: React.FC<IProps> = ({
  processosBeneficio,
  plano
}) => {


  if (processosBeneficio !== null && processosBeneficio !== undefined) {
    return (
      <Row>
        <Col tamanho={"md-6"}>
          <Card titulo={plano.DS_PLANO}>
            {plano.DS_CATEGORIA}
          </Card>
        </Col>
        <Col tamanho={"md-6"}>
          <Card titulo={"Data de Início do Benefício"}>
            {processosBeneficio.DT_INICIO_FUND}
          </Card>
        </Col>
        <Col tamanho={"md-6"}>
          <Card titulo={"Tipo de Benefício"}>
            {processosBeneficio.DS_ESPECIE}
          </Card>
        </Col>
        <Col tamanho={"md-6"}>
          <Card titulo={"Situação"}>
            {processosBeneficio.DS_SITUACAO}
          </Card>
        </Col>
      </Row>
    )
  }

  return (
    null
  );
}